import { render, staticRenderFns } from "./UpdateAccount.vue?vue&type=template&id=37115f1a"
import script from "./UpdateAccount.vue?vue&type=script&lang=js"
export * from "./UpdateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports